import React, {Component} from 'react';
import Title from '../../SubscriptionsInfo/Title/Title';
import List from '../../SubscriptionsInfo/List/SubscriptionList';
import AsyncSearchBar from '../../SubscriptionsInfo/SearchBar/AsyncSearchBar';
import Page from '../../framework/Page/Page';
import UsersTable from './UsersTable';

import './user-info.css';
import {downLoadCSVFunc} from "../../../utils/utility";
import moment from "moment/moment";

class Users extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      requestParams: {
        clientId: '',
        pageNumber: 1,
        pageSize: 15,
        sortColumn: 'clientName',
        order: 'asc'
      },
      resultExpand: false
    }
  }
  componentDidMount () {
    this.props.getClientBusinessTotal();
    this.props.usersSearch(this.state.requestParams);
    this.props.usersAll();
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.users_results.clientUsers && this.throttle) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          pageSize: nextProps.users_results.clientUsers.total
        }
      }, () => {
        this.props.getAllUsersSearch(this.state.requestParams)
      })
      this.throttle = false;
    }
  }
  nextBeClick (page) {
    this.pageAbleFunc(page)
  }
  previousBeClick (page) {
    this.pageAbleFunc(page)
  }
  goToPage (page) {
    this.pageAbleFunc(page)
  }
  pageAbleFunc (val) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageNumber: val,
        pageSize: 15,
      }
    }, () => {
      this.props.usersSearch(this.state.requestParams);
    })
  }
  handleSearch (selectedItem) {
    let obj = {}
    if (selectedItem === '') {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: '',
          pageNumber: 1,
          pageSize: 15,
        },
        resultExpand: false
      }
      this.goToPage(1)
    } else {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: selectedItem,
          pageNumber: 1,
          pageSize: 15,
        },
        resultExpand: true
      }
    }
    this.props.clearUsersSearch()
    this.setState(obj, () => {
      this.props.usersSearch(this.state.requestParams);
    })
  }
  handleDownload () {
    let title = 'AudienceAnywhere Clients and Business Units Users ,,,,,,\r\n'
    let clients = `Client Users,${this.props.client_users_total[0].value},,,,\r\n`;
    let join = `Business Unit Users,${this.props.client_users_total[1].value},,,,\r\n`;
    let data = '';
    const childrenFun = (item) => {
      data += `"${item.clientName}",${item.bizUnitName||''},${item.user.username||''},${item.user ? item.user.role.name : ''},${item.user ? item.user.email : ''},${item.user.status || ''},${item.user ? moment(item.user.lastLoggedonDatetime).format('M/DD/YY') : ''}\r\n`;
    }
    for (const v of this.props.all_users_results.clientUsers.data) {
      if (v.children) {
        data += `"${v.clientName}",${v.bizUnitName||''},${v.user ? v.user.username : ''},${v.user ? v.user.role.name : ''},${v.user ? v.user.email : ''},${v.user.status || ''},${v.user ? moment(v.user.lastLoggedonDatetime).format('M/DD/YY') : ''}\r\n`;
        v.children.forEach(childrenFun)
      } else {
        data += `"${v.clientName}",${v.bizUnitName||''},${v.user ? v.user.username : ''},${v.user ? v.user.role.name : ''},${v.user ? v.user.email : ''},${v.user.status || ''},${v.user ? moment(v.user.lastLoggedonDatetime).format('M/DD/YY') : ''}\r\n`;
      }
    }
    let csv_string =
      title +
      clients +
      join +
      ',,,,,\r\n' +
      'Client Name,Business Unit Name,User name,Role,Email,Status,Last Logged On\r\n' +
      data
    downLoadCSVFunc(csv_string.trim(), 'AA_Client_Business_Users_' + moment().format("YYYYMMDD") );
  }
  handleSortByClientName () {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageSize: 15,
        order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
      }
    }, () => {
      this.props.usersSearch(this.state.requestParams);
    })
  }
  render () {
    return (
      <div className="dashboard-user-info subscription-info">
        <div className="title-wrapper">
          <Title
            crumb="Users"
            handleDownload={() => this.handleDownload()}
          />
        </div>
        <div className="dashboard-user-container">
          <div className="common-wrapper">
            <h2>
              TOTAL NUMBER OF CLIENT/BUSINESS UNITS
            </h2>
            <div className="list">
              <List
                data={this.props.client_users_total}
              />
            </div>
          </div>
          <div className="common-wrapper mt-20">
            <h2 className="border-title">
              USERS
            </h2>
            <div className="search-bar">
              <AsyncSearchBar
                clients={this.props.clients}
                handleSearch={(selectedItem) => this.handleSearch(selectedItem)}
                token={this.props.token}
                resultSet={this.props.all_users_results}
              />
              <div className="spread-table-wrapper">
                <UsersTable
                  expandAll={this.state.resultExpand}
                  handleSortByClientName={() => this.handleSortByClientName()}
                  tableHeaderArr={
                    [
                      {label: 'Client Name', value: 0},
                      {label: 'Business Unit Name', value: 1},
                      {label: 'User Name', value: 2},
                      {label: 'Role', value: 3},
                      {label: 'Email', value: 4},
                      {label: 'Status', value: 5},
                      {label: 'Last Logged On', value: 6}
                    ]
                  }
                  tableHeaderWidthStyle={
                    ['18%', '16%', '12%', '14%', '18%', '10%', '10%']
                  }
                  bodyDataArr={
                    this.props.users_results.clientUsers ?
                      this.props.users_results.clientUsers.data : []
                  }
                  renderCols={{
                    addCol: '',
                    cols: [
                      'clientName',
                      'bizUnitName',
                      'industry',
                      'createdTime',
                      'status'
                    ]
                  }}
                />
                <Page
                  nextBeClick={(page) => this.nextBeClick(page)}
                  pageNumber={this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageNumber}
                  pageCount={this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageCount}
                  pageSize={this.props.users_results.clientUsers && this.props.users_results.clientUsers.pageSize}
                  nextGroupBeClick={(page) => this.nextGroupBeClick(page)}
                  previousGroupBeClick={(page) => this.previousGroupBeClick(page)}
                  previousBeClick={(page) => this.previousBeClick(page)}
                  pageBeClick={(page) => this.pageBeClick(page)}
                  total={this.props.users_results.clientUsers && this.props.users_results.clientUsers.total}
                  hasNext={this.props.users_results.clientUsers && this.props.users_results.clientUsers.hasNext}
                  hasPrevious={this.props.users_results.clientUsers && this.props.users_results.clientUsers.hasPrevious}
                  pagePlus={true}
                  selectRows={(page, row) => this.selectRows(page, row)}
                  goToPage={(page) => this.goToPage(page)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Users;


// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/Users/Index.jsx